import React from "react";
import UsesCasesImg from "../assets/images/usecases-img1.png";

const UseCases = () => {
  return (
    <div className="use-cases-section mt-4">
      <h3>Use Cases</h3>
      <div className="use-cases-grid">
        <div className="use-cases-card">
          <img src={UsesCasesImg} alt="UsesCasesImg" className="w-100 block" />
          <div className="d-flex justify-content-between mb-2">
            <h6>26 Sep, 2024</h6>
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
              >
                <path
                  d="M3.59961 11.6L11.5996 3.6M11.5996 3.6L3.59961 3.6M11.5996 3.6L11.5996 11.6"
                  stroke="white"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
          <h2>
            Harnessing the Power of a Data Marketplace: Benefits for Your
            Business
          </h2>
        </div>
        <div className="use-cases-card">
          <img src={UsesCasesImg} alt="UsesCasesImg" className="w-100 block" />
          <div className="d-flex justify-content-between mb-2">
            <h6>26 Sep, 2024</h6>
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
              >
                <path
                  d="M3.59961 11.6L11.5996 3.6M11.5996 3.6L3.59961 3.6M11.5996 3.6L11.5996 11.6"
                  stroke="white"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
          <h2>
            Harnessing the Power of a Data Marketplace: Benefits for Your
            Business
          </h2>
        </div>
        <div className="use-cases-card">
          <img src={UsesCasesImg} alt="UsesCasesImg" className="w-100 block" />
          <div className="d-flex justify-content-between mb-2">
            <h6>26 Sep, 2024</h6>
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
              >
                <path
                  d="M3.59961 11.6L11.5996 3.6M11.5996 3.6L3.59961 3.6M11.5996 3.6L11.5996 11.6"
                  stroke="white"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
          <h2>
            Harnessing the Power of a Data Marketplace: Benefits for Your
            Business
          </h2>
        </div>
      </div>
    </div>
  );
};

export default UseCases;
